export const stylesRefs = {
  scheduleItemRow: 'ScheduleItem_scheduleItemRow',
  scheduleItemFirstColumn: 'ScheduleItem_scheduleItemFirstColumn',
  scheduleItemDateContainer: 'ScheduleItem_scheduleItemDateContainer',
  scheduleItemCell: 'ScheduleItem_scheduleItemCell',
  scheduleItemHeaderDateContainer: 'ScheduleItem_scheduleItemHeaderDateContainer',
  scheduleItemHeaderCell: 'ScheduleItem_scheduleItemHeaderCell',
  scheduleItemHeaderOffDaysCell: 'ScheduleItem_scheduleItemHeaderOffDaysCell',
  gridOverlay: 'ScheduleItem_gridOverlay',
  gridLine: 'ScheduleItem_gridLine',
  mergedCellContent: 'ScheduleItem_mergedCellContent',
}
